import template from './item_type.all.html';
import controller from './item_type.all.controller';
import './item_type.all.scss';

let itemTypeAllComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default itemTypeAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/item_type/all/item_type.all.component.js